import { Injectable } from '@angular/core';

import { AutenticacionService } from './autenticacion.service';
import { Constante } from '../nucleo/constante/constante';

@Injectable({
  providedIn: 'root'
})

export class AutorizacionService {

  constructor(private autenticacionService: AutenticacionService) { }

  authorize(codigoPermiso: string): boolean {
    let result =  false;
    try {
      if (codigoPermiso) {
        let permisos = this.autenticacionService.obtenerPermisos();

        if (codigoPermiso.substring(0, 5) === Constante.MENU) {
          result = permisos.menu.filter(permiso => Constante.MENU + permiso === codigoPermiso).length > 0;
        }
        if (codigoPermiso.substring(0, 7) === Constante.OPCION) {
          result = permisos.opcion.filter(permiso => Constante.OPCION + permiso === codigoPermiso).length > 0;
        }
      }
    } catch (e) {
      return true;
    }
    return result;
  }
}
